import React from 'react';
import { Progress } from 'antd';

interface Props {
  progress: number; // 0.0 → 1.0
}

export function UploadProgressBar({ progress }: Props) {
  return (
    <Progress
      percent={Math.round(progress * 100)}
      showInfo={false}
      size="small"
      strokeColor="#1677ff"
      className="m-0"
    />
  );
}
